<template>
  <div class="modal fade" role="dialog" aria-hidden="true" @click="close">
    <div class="modal-dialog" role="document" @click.stop>
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'

export default {
  name: 'ModalDialog',
  props: {
    onClose: { type: Function, default: null },
    focused: { type: String, default: null }
  },

  mounted () {
    this.modalInstance = new Modal(this.$el)
    // If the esc button is typed, close modal.
    document.addEventListener('keydown', this.handleKeydown)
    this.open()

    if (this.focused) {
      // Unfortunately there is almost no way to set the
      // focus on an element for a bootstrap dialog other
      // than this... unless we want to use JQuery
      setTimeout(() => {
        let el = document.getElementById(this.focused)
        if (el) {
          el.focus()
        }
      }, 250)
    }
  },

  data () {
    return {
      modalInstance: null
    }
  },

  beforeDestroy () {
    this.close()
    document.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    handleKeydown (e) {
      if (e.keyCode === 27) {
        this.close()
      }
    },

    close () {
      if (this.isDef(this.modalInstance)) {
        this.modalInstance.hide()
      }

      // Next, call a defined callback.
      if (this.onClose !== null) {
        this.onClose()
      }
    },

    open () {
      // First, call a defined callback.
      if (this.isDef(this.onOpen)) {
        this.onOpen()
      }

      this.modalInstance.show()
    },

    isDef (obj) {
      return typeof obj !== 'undefined' && obj !== null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dialog/ModalDialog.vue